import { getIsSafeUrl } from './getIsSafeUrl.util';
import { getIsSafeUrlPath } from './getIsSafeUrlPath.util';

/**
 * Sanitizes a URL for safe use in attributes such as href and src.
 *
 * Accepts a URL as a string. Ensures that the URL string is a valid URL or a
 * non-relative URL path, and that the URL does not use a protocol which would
 * pose a security risk if the URL is used in attributes such as href and src.
 */
export const sanitizeUrlOrUrlPath = (
  urlOrUrlPath: string | null | undefined,
): string | null => {
  if (!urlOrUrlPath) {
    return null;
  }

  if (getIsSafeUrl(urlOrUrlPath) || getIsSafeUrlPath(urlOrUrlPath)) {
    return urlOrUrlPath;
  }

  return null;
};
